module.exports = __webpack_public_path__ + "static/media/extra_oral_front_small.9540e0e1.png";